const theme = {
  header: {
    secondary: {
      backgrounColorDesktop: 'red'
    }
  }
}

export default theme
